export default __webpack_public_path__ + "static/media/cook.d16cac66.png";